import {
  emergencyContactsCreateTranslation,
  EmergencyContactsCreateTranslation,
} from '@/assets/locales/views/emergencyContacts/create/emergencyContactsCreate.translation.pl.ts';
import {
  emergencyContactsDetailsTranslation,
  EmergencyContactsDetailsTranslation,
} from '@/assets/locales/views/emergencyContacts/details/emergencyContactsDetails.translation.pl.ts';
import {
  emergencyContactsListTranslation,
  EmergencyContactsListTranslation,
} from '@/assets/locales/views/emergencyContacts/list/emergencyContacts.list.translation.pl.ts';

export type EmergencyContactsTranslation = {
  create: EmergencyContactsCreateTranslation;
  details: EmergencyContactsDetailsTranslation;
  list: EmergencyContactsListTranslation;
};

export const emergencyContactsTranslation: EmergencyContactsTranslation = {
  create: emergencyContactsCreateTranslation,
  details: emergencyContactsDetailsTranslation,
  list: emergencyContactsListTranslation,
};
